"use client";

import useMediaQuery from "@/hooks/useMediaQuery";

const breakPoints = {
  sm: "300px",
  md: "1024px",
  lg: "1280px",
  xl: "1536px",
  "2xl": "1920px",
  "3xl": "3000px",
};

type BreakpointKey = keyof typeof breakPoints;

function useBreakPoint<K extends BreakpointKey>(breakpointKey: K) {
  const bool = useMediaQuery(`(min-width: ${breakPoints[breakpointKey]})`);
  const capitalizedKey = breakpointKey[0].toUpperCase() + breakpointKey.substring(1);
  type Key = `is${Capitalize<K>}`;
  return { [`is${capitalizedKey}`]: bool } as Record<Key, boolean>;
}

export default useBreakPoint;
